function hasPersistedId(row) {
  return row && row.id !== undefined && row.id !== null
}

function findPurchaseDetailIndex(rows, target) {
  if (!Array.isArray(rows) || !target) return -1

  if (hasPersistedId(target)) {
    return rows.findIndex(
      (row) => hasPersistedId(row) && String(row.id) === String(target.id),
    )
  }

  return rows.indexOf(target)
}

function removePurchaseDetail(rows, target) {
  const index = findPurchaseDetailIndex(rows, target)
  if (index === -1) return false

  const row = rows[index]
  if (hasPersistedId(row)) {
    row.delete = true
    rows.splice(index, 1, row)
  } else {
    rows.splice(index, 1)
  }

  return true
}

module.exports = {
  findPurchaseDetailIndex,
  removePurchaseDetail,
}
